import { useState } from "react";
import axios from "../axios";
import { toast } from "sonner";

export const useTriviaQuestions = () => {
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmittimg] = useState(false);
  const [showGameOver, setShowGameOver] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [results, setResults] = useState([]);
  const [selectedAnswers, setSelectedAnswers] = useState([]);
  const [timeLeft, setTimeLeft] = useState(60);
  const [categories, setCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [brandData, setBrandData] = useState(null);

  const getTrivaCategories = async (brandId) => {
    try {
      setLoadingCategories(true);
      const res = await axios.get(`/audiences/trivia/brand/${brandId}`);

      if (res.status === 200) {
        setLoadingCategories(false);
        setCategories(res?.data);
      }
    } catch (err) {
      setLoadingCategories(false);
      toast.error(
        err?.response?.data?.message || "Failed to fetch trivia categories",
      );
    }
  };

  const handleshowTriviaQuestions = async (triviaId) => {
    setLoading(true);
    try {
      const res = await axios.get(`/audiences/trivia/${triviaId}/questions`);

      if (res.status === 200) {
        const time = res?.data?.data?.time_limit;
        setLoading(false);
        setTimeLeft(time * 60);
        setQuestions(res?.data?.data?.questions);
        setBrandData(res?.data?.data?.brand);

        // Return the timer duration for the new timer hook
        return time * 60;
      }
    } catch (err) {
      setLoading(false);
      console.error(" Trivia Question Error:", err);
      toast.error(
        err?.response?.data?.message || "Failed to fetch trivia question",
      );

      // Return null on error
      return null;
    }
  };

  const handleSubmitAnswer = async (triviaId, isArena) => {
    try {
      setSubmittimg(true);
      const res = await axios.post(
        `/audiences/trivia/${triviaId}`,
        JSON.stringify({
          questions: selectedAnswers,
          is_arena: isArena,
        }),
      );
      if (res.status === 200) {
        setResults(res?.data?.data);
        setSubmittimg(false);
        setShowGameOver(true);
      }
    } catch (error) {
      setSubmittimg(false);
      toast.error(error?.response?.data?.message);
    }
  };

  return {
    handleshowTriviaQuestions,
    questions,
    loading,
    handleSubmitAnswer,
    submitting,
    setSubmittimg,
    selectedAnswers,
    setSelectedAnswers,
    showGameOver,
    setShowGameOver,
    results,
    setTimeLeft,
    timeLeft,
    getTrivaCategories,
    loadingCategories,
    categories,
    brandData,
  };
};
